import type { OrderDetailPerspectiveView } from '@/api/hooks/useOrderDetails'
import { formatDeliveryWindow } from '@/api/hooks/useOrders'
import { formatCompactDateTime } from '@/utils/dateFormatters'
import { Texto, Vertical } from '@gravitate-js/excalibrr'

interface OrderInfoCardProps {
  order: OrderDetailPerspectiveView
}

export function OrderInfoCard({ order }: OrderInfoCardProps) {
  const deliveryWindow = formatDeliveryWindow(
    order.delivery_window_start,
    order.delivery_window_end,
  )

  // Access fields from order with type assertions
  const hauledBy = (order as { hauled_by?: string }).hauled_by
  const hauledFor = (order as { hauled_for?: string }).hauled_for
  const assignedTo = (order as { assigned_to?: string }).assigned_to
  const createdBy = (order as { created_by?: string }).created_by
  const createdDate = (order as { created_date?: string }).created_date
  const updatedBy = (order as { updated_by?: string | null }).updated_by
  const updatedDate = (order as { updated_date?: string | null }).updated_date

  return (
    <Vertical
      className='bg-1 rounded-md p-4 overflow-visible'
      gap={16}
      style={{ height: '100%' }}
    >
      <InfoField label='Hauled By' value={hauledBy} />
      <InfoField label='Hauled For' value={hauledFor} />
      <InfoField label='Assigned To' value={assignedTo} />
      <InfoField label='Delivery Window' value={deliveryWindow} />
      <InfoField label='Partner Order #' value={order.partner_order_number} />
      <InfoField label='Created By' value={createdBy} />
      <InfoField
        label='Created At'
        value={formatCompactDateTime(createdDate)}
      />
      {updatedBy && <InfoField label='Updated By' value={updatedBy} />}
      {updatedDate && (
        <InfoField
          label='Updated At'
          value={formatCompactDateTime(updatedDate)}
        />
      )}
    </Vertical>
  )
}

interface InfoFieldProps {
  label: string
  value: string | null | undefined
}

function InfoField({ label, value }: InfoFieldProps) {
  return (
    <Vertical gap={2} style={{ flex: 'none', height: 'auto' }}>
      <Texto
        className='text-muted-foreground uppercase tracking-wide'
        style={{ fontSize: 11, fontWeight: 600 }}
      >
        {label}
      </Texto>
      <Texto style={{ fontSize: 13 }}>{value || '-'}</Texto>
    </Vertical>
  )
}
